import React from 'react';
import styled from 'styled-components';

const StepWrapper = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 32px;
  width: 100%;
  position: relative;
`;

/**
 * Drawn between the steps rather than as one line behind them, so the labels do not need an
 * opaque background to mask it. That masking assumed a white page and showed as white chips
 * on any other background.
 */
const Connector = styled.div`
  flex: 1;
  height: 1px;
  min-width: 16px;
  margin: 0 8px;
  background-color: #cdd5df;
`;

const StepsContainer = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  position: relative;
`;

const Step = styled.div<{ active?: boolean; completed?: boolean }>`
  display: flex;
  align-items: center;
  color: ${({ active }) => (active ? '#1a1a1a' : '#ccc')};
  font-weight: 400;
  font-size: 14px;
`;

const StepLabel = styled.span<{ currentStep: boolean }>`
  @media (max-width: 768px) {
    /* Hide all step labels except for the current step */
    display: ${({ currentStep }) => (currentStep ? 'inline' : 'none')};
  }
`;

const StepCircle = styled.div<{ active?: boolean; completed?: boolean }>`
  width: 20px;
  height: 20px;
  border-radius: 50%;
  border: 1px solid ${({ active }) => (active ? '#44c496' : '#ccc')};
  margin-right: 8px;
  flex-shrink: 0;
  position: relative;

  &:before {
    content: '';
    width: 10px;
    height: 10px;
    border-radius: 50%;
    background-color: ${({ active }) => (active ? '#44c496' : '#ccc')};
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    transition: background-color 0.3s ease-in-out, border-color 0.3s ease-in-out;
  }
`;

type StepIndicatorProps = {
  currentStep: number;
  steps: string[];
};

const FormStepProgress: React.FC<StepIndicatorProps> = ({ currentStep, steps }) => (
  <StepWrapper>
    <StepsContainer>
      {steps.map((label, index) => (
        <React.Fragment key={label}>
          {index > 0 && <Connector />}
          <Step active={index <= currentStep}>
            <StepCircle active={index <= currentStep} />
            <StepLabel currentStep={index === currentStep}>{label}</StepLabel>
          </Step>
        </React.Fragment>
      ))}
    </StepsContainer>
  </StepWrapper>
);

export { FormStepProgress };
